import { ActionReducerMap } from '@ngrx/store';
import {
  IStoreCategoriesState,
  storeCategoriesReducer,
} from './categories/store-categories.reducer';
import { IStoreProfileState, storeConfigurationReducer } from './configuration/store-configuration.reducer';
import { IStoreCouponsState, storeCouponsReducer } from './coupons/store-coupons.reducer';
import {
  IStoreImagesState,
  storeImagesReducer,
} from './images/store-images.reducer';
import {
  IStoreOrdersState,
  storeOrdersReducer,
} from './orders/store-orders.reducer';
import {
  IStoreProductsState,
  storeProductsReducer,
} from './products/store-products.reducer';
import {
  IStoreVariationsState,
  storeVariationsReducer,
} from './variations/store-variations.reducer';

export interface IStoreState {
  categoriesState: IStoreCategoriesState;
  imagesState: IStoreImagesState;
  ordersState: IStoreOrdersState;
  productsState: IStoreProductsState;
  couponsState: IStoreCouponsState;
  variationsState: IStoreVariationsState;
  configurationState: IStoreProfileState
}

export const ecommerceReducer: ActionReducerMap<IStoreState> = {
  categoriesState: storeCategoriesReducer,
  imagesState: storeImagesReducer,
  ordersState: storeOrdersReducer,
  productsState: storeProductsReducer,
  couponsState: storeCouponsReducer,
  variationsState: storeVariationsReducer,
  configurationState: storeConfigurationReducer
};
